// src/firebase-config.js
import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore'; // For Firestore
import { getDatabase } from 'firebase/database';  // For Realtime Database
import { getAuth } from 'firebase/auth';
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { 
  collection, 
  doc, 
  setDoc, 
  getDoc,
  deleteDoc, 
  onSnapshot, 
  getDocs, 
  addDoc,
  updateDoc,       // <-- Add updateDoc here
  query,        // Import query
  where,        // Import where
  orderBy      // <-- Import orderBy
} from 'firebase/firestore'; 

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
  };

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const firestore = getFirestore(app); // Firestore
export const database = getDatabase(app);  // Realtime Database
export const auth = getAuth(app);
export const storage = getStorage(app);
export { ref, uploadBytesResumable, getDownloadURL };
export { 
  collection, 
  doc, 
  setDoc,
  getDoc,
  deleteDoc, 
  updateDoc,      // <-- Export updateDoc here
  onSnapshot, 
  getDocs, 
  addDoc, 
  query,      // Export query
  where,      // Export where
  orderBy     // <-- Export orderBy
};